var _circle, _path, _path2, _g, _mask, _rect, _path3, _rect2, _rect3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipedgas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_914)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 235.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.794 146.203L236.858 105.96L264.799 130.773L278.352 144.535L287.318 169.974L280.646 192.91L270.011 198.957C259.507 202.295 253.331 207.506 243.113 207.506C232.896 207.506 229.977 202.918 229.977 202.918L215.173 196.038L203.496 183.527L201.828 164.552L210.794 146.203Z",
    fill: "#FEF4E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1580_914",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 100,
    width: 93,
    height: 108
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.578 100.441H289.19V207.572H197.578V100.441Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1580_914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.241 102.789C225.14 135.127 200.289 149.835 200.289 173.907C200.289 189.707 212.42 199.812 229.286 204.712C224.313 201.477 218.034 194.555 218.034 188.034C218.034 175.685 224.269 171.685 228.173 158.275C237.539 165.093 238.312 175.347 238.312 175.347C238.312 175.347 249.428 156.885 245.918 136.935C264.479 151.522 271.365 166.059 271.264 178.136C271.156 190.799 263.427 200.754 255.638 205.224C272.616 203.148 286.471 190.034 286.471 173.664C286.471 149.588 270.444 131.73 233.241 102.789Z",
    stroke: "#4045A1",
    strokeWidth: 5.44262,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_1580_914",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.812,
    y: 222.07,
    width: 95.7596,
    height: 89.7058,
    rx: 6.48193
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 199.812,
    y: 222.07,
    width: 95.7596,
    height: 89.7058,
    rx: 6.48193,
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 18,
    mask: "url(#path-6-inside-1_1580_914)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M293.195 242.806H377.973C379.068 242.806 379.955 243.693 379.955 244.788V289.059C379.955 290.154 379.068 291.041 377.973 291.041H293.195V242.806Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 113.688,
    y: 238.306,
    width: 95.7596,
    height: 57.2356,
    rx: 6.48193,
    fill: "#FEF4E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 113.688,
    y: 238.306,
    width: 95.7596,
    height: 57.2356,
    rx: 6.48193,
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M271.812 394.45V309.672H225.559C224.464 309.672 223.577 310.559 223.577 311.654V394.45C223.577 395.544 224.464 396.432 225.559 396.432H269.831C270.925 396.432 271.812 395.544 271.812 394.45Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.961 238.306H203.392V295.541H113.961",
    stroke: "black",
    strokeWidth: 9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipedgas);
export default __webpack_public_path__ + "static/media/piped gas.9c965a1aff5866e30f0487c65c2442ed.svg";
export { ForwardRef as ReactComponent };